module.exports = __webpack_public_path__ + "img/empty_chart.0a319c21.png";